import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Setup from './views/Setup.vue'

import adminRoutes from './router.admin'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: { template: "Template" }
    },
    {
      path: '/setup',
      name: 'setup',
      component: Setup,
      props: {  }
    },
    {
      path: "/admin",
      name: 'admin',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "splash" */ './views/Admin.vue'),
      children: [...adminRoutes],
    },
    {
      path: '/s/:location/:code',
      name: 'signin',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "signin" */ './views/SignIn/SignIn.vue')
    },
    {
      path: '/j/:id/:joinCode',
      name: 'join',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "join" */ './views/Public/Join.vue')
    },
    {
      path: '/t/:code',
      name: 'signinContinue',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "signin" */ './views/SignIn/SignInContinue.vue')
    },
    {
      path: '/venue/:id/NewQRCode',
      name: 'newQRCode',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "signin" */ './views/SignIn/SignIn.vue')
    }
  ]
})
